import type {
  PaginatedSearchResponseViewListWeddingCardView,
  SearchWeddingsRequest,
  WeddingCardView,
} from '@zola/svc-marketplace-ts-types';

import type { VendorSearchRequest } from '~/pages/couples/explore/components/SearchResults/types/types';
import type { OptionalNullable } from '~/types/utils';
import type { ClientApiServiceType } from '~/util/apiService';

import type { ServerApiServiceType } from '../server/util/apiService';

const getRealWeddingsSearchParameters = ({
  selectedLocation,
}: VendorSearchRequest): OptionalNullable<SearchWeddingsRequest> | null => {
  if (!selectedLocation?.geoCoordinates) return null;

  const latitude = selectedLocation.geoCoordinates.latitude;
  const longitude = selectedLocation.geoCoordinates.longitude;

  return {
    published: true,
    offset: 0,
    limit: 12,
    facetGroups: [],
    randomize: true,
    latitude,
    longitude,
  };
};

export const getRealWeddingForVendorSearch = (
  vendorSearch: VendorSearchRequest,
  apiService: ServerApiServiceType | ClientApiServiceType
): Promise<WeddingCardView[]> => {
  const request = getRealWeddingsSearchParameters(vendorSearch);
  if (!request) return Promise.resolve([]);
  return getRealWeddings(request, apiService);
};

/**
 * Runs a faceted search on real weddings.  Filters out weddings that don't have colors or photos
 */
export const getRealWeddings = (
  request: OptionalNullable<SearchWeddingsRequest>,
  apiService: ServerApiServiceType | ClientApiServiceType
) => {
  return apiService
    .post<PaginatedSearchResponseViewListWeddingCardView, OptionalNullable<SearchWeddingsRequest>>(
      '/web-marketplace-api/v1/wedding/search',
      request
    )
    .then(({ entities: receivedWeddings }) => {
      if (receivedWeddings) {
        return receivedWeddings.filter((wedding) => !!wedding?.colors && !!wedding?.photos?.length);
      }
      return [];
    })
    .catch(() => {
      return [];
    });
};
